"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutoSuggestionWrapper = exports.ErrorWrapper = exports.SuggestionsWraper = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  position: relative;\n\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  padding-left: 15px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  width: 100%;\n  height: 0;\n  position: relative;\n\n  > div {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 999999;\n    width: 100%;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var SuggestionsWraper = _styledComponents["default"].div(_templateObject());

exports.SuggestionsWraper = SuggestionsWraper;

var ErrorWrapper = _styledComponents["default"].span(_templateObject2(), function (props) {
  return "".concat(props.theme.palette.error.main);
});

exports.ErrorWrapper = ErrorWrapper;

var AutoSuggestionWrapper = _styledComponents["default"].div(_templateObject3(), function (props) {
  return props.selectboxstyling ? " input { padding-right: 35px !important; z-index: 9999; position: relative; } " : '';
});

exports.AutoSuggestionWrapper = AutoSuggestionWrapper;